import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { datePipe, delayedFunctionCall } from '@piqet-angular/data';
import { reportTitals } from '@piqet-angular/shared';
import { ReportsService } from 'libs/data/src/lib/services/report/reports.service';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';

@Component({
  selector: 'piqet-angular-product-waste-report',
  templateUrl: './product-waste-report.component.html',
  styleUrls: ['./product-waste-report.component.scss'],
})
export class ProductWasteReportComponent {
  profilePic = './assets/images/defaultProfile.jpg';
  piqetLogo = './assets/images/Piqet_NewLogo.svg';
  organizationImage = './assets/images/GlobalWarming.png';

  @Input() reportData: any;
  reportResource = reportTitals;
  mainProjectName!: string;
  remainingProjectName!: string;
  tableId: number = 3;
  lblProductLossFigureId = 1;
  @Output() checkContent = new EventEmitter<{ projectName: any }>();
  constructor(private sharedService: SharedService, private reportService: ReportsService) {}

  ngOnInit() {}

  ngAfterViewInit() {
    if (!!this.reportData && this.reportData.isExport) {
      this.checkContent.emit({ projectName: this.reportData.projectName });
    }
  }
  exportPdfFun() {
    if (!!this.reportData && this.reportData.isExport) {
      this.checkContent.emit({ projectName: this.reportData.projectName });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.reportData = changes['reportData'].currentValue;
    this.getRemainingText();
    delayedFunctionCall(this.exportPdfFun, 3000, this);
  }

  getRemainingText(): string {
    const parts = this.reportData.projectName.split(' - ');
    this.mainProjectName = parts[0];
    if (parts.length > 1) {
      this.remainingProjectName = parts.slice(1).join(' - ');
    }
    return '';
  }
  getFormateDate(date: any) {
    return datePipe(date);
  }
}
